import { render, staticRenderFns } from "./SelectManyEvaluations.vue?vue&type=template&id=8fd8ce8a&scoped=true"
import script from "./SelectManyEvaluations.vue?vue&type=script&lang=js"
export * from "./SelectManyEvaluations.vue?vue&type=script&lang=js"
import style0 from "./SelectManyEvaluations.vue?vue&type=style&index=0&id=8fd8ce8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fd8ce8a",
  null
  
)

export default component.exports